import { SocialDefaultImage, WhitepaperCovidCoverThumb , Whitepaperiotthumb , Cybersecurityhumb} from "../utils/imageConst";

export const HomeMeta = {
      metaTitle: `Best Taxi Software | Taxi Management Software | Yelowsoft`,
      metaDescription: "Streamline your taxi operations with our taxi management software. Manage taxi bookings, taxi scheduling, drivers, & fleets efficiently from anywhere, anytime.",
      keywords: "Taxi dispatch software",
      ogTitle: "Cloud Based Taxi Dispatch System, Taxi Booking App, Taxi Management Software",
      ogDescription: "YelowSoft has a versatile cloud based taxi dispatch system. It is a robust taxi booking system which consists of several features which will contribute in expanding your business. Here we have described all the essential reasons as to why you should go for YelowSoft’s solution.",
      ogType: "website",
      ogSiteName: "",
      ogImage: SocialDefaultImage,
      twitterCard: "",
      twitterCreator: "",
      twitterTitle: "Cloud Based Taxi Dispatch System, Taxi Booking App, Taxi Management Software",
      twitterDescription: "YelowSoft has a versatile cloud based taxi dispatch system. It is a robust taxi booking system which consists of several features which will contribute in expanding your business. Here we have described all the essential reasons as to why you should go for YelowSoft’s solution.",
      twitterImage: SocialDefaultImage
};

export const BlogMeta = {
      metaTitle: `Subscribe to our blog & learn all about our on-demand solutions`,
      metaDescription: "Gain insights by reading the latest news and articles about on-demand businesses and our automated solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogCateroyMeta = {
      metaTitle: `Subscribe to our blog & learn all about our on-demand solutions`,
      metaDescription: "Gain insights by reading the latest news and articles about on-demand businesses and our automated solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const BlogAuthorMeta = {
      metaTitle: `Subscribe to our blog & learn all about our on-demand solutions`,
      metaDescription: "Gain insights by reading the latest news and articles about on-demand businesses and our automated solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CaseStudiesMeta = {
      metaTitle: `All of our client success stories`,
      metaDescription: "Read YelowSoft’s case studies to see how our clients automated their businesses with us.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ProductMeta = {
      metaTitle: `Taxi Dispatch Product Features, Ordering & Delivery Platform`,
      metaDescription: "Stay updated with our taxi dispatch and delivery platform latest products, features, and improvements. Empowering businesses with innovative solutions. See now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ResourcesMeta = {
      metaTitle: `On-Demand Delivery System & Taxi Booking Platform Resources`,
      metaDescription: "Discover insightful blogs on on-demand delivery system & taxi booking platform at Yelowsoft Resources. Elevate your understanding, stay informed and empowered.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WebinarsMeta = {
      metaTitle: `Watch our FREE educational Webinars`,
      metaDescription: "Checkout our educative webinar sessions and learn how our product expert team take on taxi industry challenges and answers them through interactive sessions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const EBookMeta = {
      metaTitle: `Automated Taxi Dispatch and Delivery Solution E-Book`,
      metaDescription: "Access our e-book on cloud-based taxi dispatch and delivery software. Get in-depth guides on critical topics & learn best practices for your business growth",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhitepaperMeta = {
      metaTitle: `Whitepaper resources for taxi industry experts`,
      metaDescription: "Know more about industry specific challenges, shifting trends, technology and much more with Yelowsoft",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ChallengesSolutionsOfGlobalMeta = {
      metaTitle: `COVID: Challenges & Opportunities for Global Transportation`,
      metaDescription: "Examine how COVID-19 impacted global transportation. Discover Yelowsoft’s On-demand delivery solution helping businesses overcome global economic disaster.",
      ogImage: WhitepaperCovidCoverThumb,
      twitterImage: WhitepaperCovidCoverThumb
};

export const ContactUsMeta = {
      metaTitle: `Get in touch with us to buy the best taxi software`,
      metaDescription: "Talk to our customer relationship experts to know more about our solution and how it can help your business to grow further. Call us today!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FreeTrialMeta = {
      metaTitle: `Taxi Dispatch & On-Demand Delivery Software Free Trial`,
      metaDescription: "Try Yelowsoft's taxi dispatch and on-demand delivery system free for 7 days with no commitments. Access all features to optimize and automate operations.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ThankYouMeta = {
      metaTitle: `Thank you for submitting your query`,
      metaDescription: "Thank you for choosing Yelowsoft. Explore how our solutions can help you achieve better growth and operational efficiency in your taxi business.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const ChauffeurlimooperatorMeta = {
      metaTitle: `Best Booking Software For Chauffeur Businesses | Yelowsoft`,
      metaDescription: "Streamline limo reservations, dispatch rides, and manage fleets with our chauffeur booking software. Improve efficiency and customer satisfaction today.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const PrivatehireoperatorMeta = {
      metaTitle: `Best Minicab & Private Hire Software UK | Yelowsoft`,
      metaDescription: "Run your minicab or private hire business smarter. Book rides, dispatch faster, and manage your fleet with the best private hire booking software UK. Try Free.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const RidehailingstartupMeta = {
      metaTitle: `Best Ride-Hailing Software for Startups | Yelowsoft`,
      metaDescription: "Start your ride-hailing business with a white-label ride-hailing app. Automate bookings, manage fleets, and grow faster. Get a free demo and launch today!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TaxiDispatchSoftwareMeta = {
      metaTitle: `Taxi Dispatch Software | Cloud-Based Dispatch System`,
      metaDescription: "Best taxi dispatch software provides cloud-based solutions for efficient cab management, real-time dispatching, and enhanced fleet operations.",
      keywords: "Taxi Dispatch Software",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RideHailingSoftwareMeta = {
      metaTitle: `Ride Hailing Software | On-Demand Ride-Hailing Platform`,
      metaDescription: "Want to automate ride hailing business? Try Yelowsoft's free ride hailing software. It automates booking, track fleets, and provides real-time performance data.",
      keywords: "Ride hailing software",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const RideHailingSoftwareUkMeta = {
      metaTitle: `Ride Hailing Software | On-Demand Ride-Hailing Platform`,
      metaDescription: "Ride Hailing Application - On-Demand Ride Hailing Software includes a powerful management portal, white-label passenger and driver apps. Streamline ride bookings, fleet tracking, and operations.",
      keywords: "Ride hailing software",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OnDemandCourierParcelDeliveryMeta = {
      metaTitle: `On-Demand Parcel Delivery Software & Solution | YelowSoft`,
      metaDescription: "A reliable On-demand parcel delivery platform designed to help optimize courier operations. Automate dispatch, tracking, invoicing & more to boost efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OurStoryMeta = {
      metaTitle: `Yelowsoft | Our Story Of Automating Taxi Businesses `,
      metaDescription: "Learn how Yelowsoft started in 2018 and evolved into a trusted taxi software provider, empowering businesses with innovative and scalable solutions.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OurUspsMeta = {
      metaTitle: `Dispatch and Delivery Software Solution USP | YelowSoft`,
      metaDescription: "Automate your business & streamline your operations with our reliable dispatch & delivery software solution. Explore our USPs to build a high quality platform.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OurClientsMeta = {
      metaTitle: `100+ global brands that trust us for taxi growth solution`,
      metaDescription: "Yelowsoft has created a happy family of 100+ brands spread across 40+ countries. Our global presence makes us the best taxi software provider company.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const SupportCenterMeta = {
      metaTitle: `Expert customer support centre for taxi businesses`,
      metaDescription: "Solve any challenge for your taxi business growth with Yelowsoft's expert customer support panel. Take Demo, Talk To Us or Read FAQs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ThirdPartyIntegrationsMeta = {
      metaTitle: `Easy to use 3rd party integrations with Yelowsoft`,
      metaDescription: "An easy to integrate software for taxi business operations management. No more struggling with multiple software to manage your business. Get Yelowsoft!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};



export const AirportTaxiTransferSolutionMeta = {
      metaTitle: `Airport Taxi Dispatch Software | Airport Transfer Platform`,
      metaDescription: "Airport taxi dispatch software simplifies airport taxi and shuttle operations with real-time flight tracking, automated dispatch, omni-channel booking, etc.",
      keywords: "Airport taxi transfer solution",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TaxiBookingSoftwareMeta = {
      metaTitle: `Taxi Booking Software | Online Taxi Booking System - Yelowsoft`,
      metaDescription: "Taxi Booking Software streamlines online chauffeur taxi bookings, dispatch, and fleet operations with real-time management and IVR integration.",
      keywords: "Taxi Booking Software Solution",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TaxiAppDevelopmentSolutionMeta = {
      metaTitle: `Taxi App Development Company | Taxi Booking Solutions`,
      metaDescription: "Yelowsoft - a SAAS-based white label taxi booking app development service provider for taxi businesses. Launch your branded taxi booking app in just 3 weeks!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const TermsofUsePageMeta = {
      metaTitle: `Cloud-base Taxi Booking & Delivery Software Terms, YelowSoft`,
      metaDescription: "Explore our taxi booking & delivery software terms of use with clear guidelines. Ensuring a transparent and secure experience for our valued users. Read now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PrivacypolicyPageMeta = {
      metaTitle: `Cloud-based Taxi Delivery Software Protection Privacy Policy`,
      metaDescription: "Your privacy is 100% secure when you use our automated taxi delivery software. See how we handle your data responsibly through our transparent privacy policy.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ManageyourmMultipleBusinesseswithsuperAppMeta = {
      metaTitle: `Manage multiple businesses easily with Yelowsoft super app`,
      metaDescription: "Easily manage diverse businesses like ride-hailing, taxi, shuttle, & corporate booking with Yelowsoft's Super App. Optimize operations and maximize efficiency.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CorporateTaxiBookingSolutionMeta = {
      metaTitle: `Corporate Taxi Booking Software | Taxi Dispatch for Business`,
      metaDescription: "Corporate Taxi Booking Software simplifies employee travel with features like taxi dispatch for business, on-demand corporate taxi booking, trip authorization and efficient billing management.",
      keywords: "Corporate Taxi Booking Software",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ShuttleBookingSoftwareMeta = {
      metaTitle: `Shuttle Booking Software | Shuttle Dispatch Software - Yelowsoft`,
      metaDescription: "Streamline shuttle bookings, dispatch, and fleet management with our shuttle booking software. Automate operations, enhance efficiency & boost customer satisfaction.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const FaqPageMeta = {
      metaTitle: `Taxi Booking, Dispatch, Ordering and Delivery System FAQs`,
      metaDescription: "Find answers to frequently asked questions about Yelowsoft's taxi booking, dispatch, ordering and delivery system. Get insight into features, pricing, & more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const Boostyourdeliverybusinessduringthecovid19Meta = {
      metaTitle: `Sustain Delivery Business During COVID-19 with YelowXpress`,
      metaDescription: "Discover how to boost your delivery business during COVID-19 with Yelowsoft's expert guidance. Implement tech solutions and prioritize safety for growth.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const DriversSubscriptionMeta = {
      metaTitle: `Driver subscription packages of our taxi booking software`,
      metaDescription: "Let your drivers enjoy unlimited rides with multiple driver subscription packages of our taxi booking software. Automate onboarding, payments, & easily.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const SmartAlgorithmMeta = {
      metaTitle: `Taxi Dispatch System Smart Algorithm for Driver | YelowSoft`,
      metaDescription: "Automated taxi dispatch platform comes with a smart algorithm that prioritizes drivers based on location, availability, & proximity to the passenger's location.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ReportsAndAnalyticsMeta = {
      metaTitle: `Taxi Booking App, Local Delivery System Reports & Analytics`,
      metaDescription: "Gain insights with our taxi booking app & delivery system reports & analytics features. Optimize strategies and make informed decisions effectively. Explore now",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OnDemandCargoDeliverySoftwareSolutionMeta = {
      metaTitle: `Logistics and Cargo Delivery Software solution | Yelowsoft`,
      metaDescription: "Optimize logistics and boost cargo deliveries with Yelowsoft's logistics and cargo delivery software solution. Automate dispatch, tracking, invoicing, and more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const ProductDemoMeta = {
      metaTitle: `Taxi Dispatch, Ordering & Delivery Product Demo | YelowSoft`,
      metaDescription: "Experience our product in action through an insightful demo. Witness firsthand how our taxi dispatch & delievry solution can transform your experience. See now!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PassengerAppMeta = {
      metaTitle: `Taxi Passenger App | Customer App for Taxi Booking System`,
      metaDescription: "Passenger App of Yelowsoft’s offers ride booking, real-time tracking, and secure payment options. A perfect customer app for taxi booking systems.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const DriverAppMeta = {
      metaTitle: `Taxi Driver App | White-Label Dispatch Driver App`,
      metaDescription: "Taxi Driver App simplifies real-time tracking, trip management, and seamless communication. Customize it as a white-label driver app for your taxi business.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const IncentivesMeta = {
      metaTitle: `Motivate your drivers with our incentive program | Yelowsoft`,
      metaDescription: "Boost driver motivation and retention with Yelowsoft’s automated driver incentive programs. Set customized targets and rewards to uplift productivity.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const SurgePricingMeta = {
      metaTitle: `Surge Price for Taxi Dispatch Software | YelowSoft`,
      metaDescription: "Elevate earnings with our taxi dispatch system’s surge pricing feature. Dynamic fare adjustments for efficient and profitable taxi operations. Learn more now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};


export const FeaturesMeta = {
      metaTitle: `Explore Yelowsoft’s Taxi Dispatch Software Features`,
      metaDescription: "Discover powerful features built for taxi, limo, and ride-hailing operators. Manage dispatch, drivers, bookings, payments & more. Explore features now.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const CarRentalSoftwareMeta = {
      metaTitle: `Streamline Operations with Yelowsoft's Car Rental Software`,
      metaDescription: "Yelowsoft's car rental software helps you manage your car rental business. It simplifies operations with automation for booking, dispatching, tracking, & more.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LimoDispatchBookingSoftwareMeta = {
      metaTitle: `Limo Dispatch Software | Limousine & Chauffeur Booking System`,
      metaDescription: "All-in-one limo reservation software to streamline dispatch, bookings & fleet management. Scale your limousine service with Yelowsoft’s smart platform.",
      keywords: "Limo Dispatch Booking Software",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const LimoDispatchBookingSoftwareUsaMeta = {
      metaTitle: `Limo booking software USA | Limousine software - Yelowsoft `,
      metaDescription: "Take control of your limo business with our limo dispatch booking software USA. Streamline bookings and deliver exceptional client experiences.",
      keywords: "Limo Dispatch Booking Software USA",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}

export const LimoDispatchBookingSoftwareAustraliaMeta = {
      metaTitle: `Limo booking software Australia | Limousine software - Yelowsoft  `,
      metaDescription: "Manage your limo business effortlessly with our limousine dispatch booking software Australia. Simplify bookings, enhance customer service, and boost your revenue.",
      keywords: "Limo Dispatch Booking Software USA",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}

export const TaxiDispatchPlatformMeta = {
      metaTitle: `Taxi Dispatch Platform - Online Dispatch System for Taxi`,
      metaDescription: "Cloud-based taxi dispatch platform to handle manual and auto dispatch requests. It offers better taxi and fleet management and real-time dispatching solutions.",
      keywords: "Taxi Dispatch Platform",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OurAdminMeta = {
      metaTitle: `Taxi Dispatch System Admin Panel | Taxi Booking Platform`,
      metaDescription: "A cloud based taxi dispatch software admin panel helps you control total taxi dispatch business. Efficiently manage fleets, optimize operations, & grow rapidly.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const OurDispatcherMeta = {
      metaTitle: `Taxi Dispatcher App | Dispatch Panel for Taxi Booking`,
      metaDescription: "Taxi Dispatcher App simplifies taxi bookings with real-time dispatching, driver coordination, and an intuitive dispatcher panel. Enhance operational efficiency with ease.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};
export const OurVendorMeta = {
      metaTitle: `Vendor App, Business App for Ordering & Delivery System`,
      metaDescription: "Vendor app for ordering & delivery enable vendors seamlessly manage orders and deliveries in a streamlined manner, enhance customer satisfaction and revenue.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PricingPageMetataxi = {
      metaTitle: `Taxi Dispatch Software | Taxi Booking App Pricing | Yelowsoft`,
      metaDescription: "Looking for Taxi Dispatch Software pricing? Check our competitive rates to optimize your taxi business operations and improve service quality.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};



export const WebBasedTaxiBookingSystemMeta = {
      metaTitle: `Taxi Web Booking System | Online Cab Booking Software`,
      metaDescription: "Turn your website into an online cab booking system with Yelowsoft and allow your customers to book rides effortlessly, boosts efficiency, & increases revenue.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}
export const TestimonialsMeta = {
      metaTitle: `Testimonials For Best Taxi Dispatch Software | Yelowsoft`,
      metaDescription: "See why taxi operators call Yelowsoft the best dispatch software for real-time booking, automation & fleet management. Watch real testimonials.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}


export const ComparePageMeta = {
      metaTitle: `Compare Yelowsoft to Other Taxi Dispatch Software Provider`,
      metaDescription: "Looking for the best taxi dispatch software? Explore the detailed comparison with others in the industry and find the one that fits your business needs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const AlternativesMeta = {
      metaTitle: `Yelowsoft Alternatives: Compare features & pricing in detail`,
      metaDescription: "Compare top Yelowsoft alternatives with different features and pricing plans. Identify the software that streamlines operations & supports your business growth.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const DemoPageMeta = {
      metaTitle: `Book a Demo: Book Your Personalized Session Today | Yelowsoft`,
      metaDescription: "Schedule a demo to get personalized demo to see our service in action and find out how it meets your needs. | Yelowsoft",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const PaymentGatewayIntegrationsMeta = {
      metaTitle: `Payment Gateway Integration for Taxi Services | Yelowsoft`,
      metaDescription: "Integrate any payment gateway with Yelowsoft’s software. Enhance your taxi business with secure, fast, and flexible payment solutions tailored to your needs.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const NotificationIntegrationsMeta = {
      metaTitle: `Notification Integration for Taxi Services | Yelowsoft`,
      metaDescription: "Yelowsoft offers the best taxi dispatch software with smart notification integrations. Automate alerts and updates easily with tools like Vonage and Fire Mobile.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const EmailIntegrationsMeta = {
      metaTitle: `Email Gateway Integration for Taxi Services | Yelowsoft`,
      metaDescription: "Integrate your taxi dispatch software with top email gateways like SendGrid, Mailgun, Sendinblue, and Mailchimp for automated and reliable email communications.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const MapIntegrationMeta = {
      metaTitle: `Map Integration for Taxi Services | Yelowsoft`,
      metaDescription: "Integrate Google Maps, Mapbox, and OpenStreetMap with Yelowsoft. Enhance your taxi dispatch with real-time navigation and accurate route management.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const GlossaryMeta = {
      metaTitle: `Taxi dispatch and ride-hailing business terms and glossary`,
      metaDescription: "Explore a comprehensive glossary of key terms in the ride-hailing, ride-sharing and taxi industry crafted by Yelowsoft to keep you ahead in your business.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhyyelowsoftpageMeta = {
      metaTitle: `Why choose Yelowsoft to automate taxi and limo business? `,
      metaDescription: "Yelowsoft simplifies taxi dispatch with automation, real-time tracking, white-label customization, and 24/7 support. Grow your taxi business seamlessly.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
};

export const WhatsappForTaxiBusinessesMeta = {
      metaTitle: `Switch from WhatsApp to Yelowsoft | Advanced Taxi Dispatch Software`,
      metaDescription: "Migrate your taxi business from WhatsApp to Yelowsoft for better automation, control, and scalability. Easy setup and advanced features for faster growth!",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}

export const ProductUpdateMeta = {
      metaTitle: `Product Update | New & Enhancement of Features | Yelowsoft`,
      metaDescription: "Have a look at the enhanced and newest features from Yelowsoft - the best taxi dispatch software for taxi businesses of all types and sizes.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}
export const SchoolbustransportationMeta = {
      metaTitle: `School Bus Transportation Software | Routing & Dispatch System`,
      metaDescription: "School Bus Transportation Software simplifies school runs with advanced routing, bus scheduling, dispatch, and scheduling tools. Ensure safe student transportation with Yelowsoft.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}
export const WebKioskAppHotelsRestaurantsReceptionsMeta = {
      metaTitle: `Concierge App | Hotel & Restaurant Taxi Booking System`,
      metaDescription: "Concierge App simplifies taxi bookings for hotels, restaurants, and reception desks. Enhance guest experience with a seamless and user-friendly taxi booker system.",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}
export const TaxiDispatchSoftwareukMeta = {
      metaTitle: `Best Taxi Dispatch Software UK | Taxi Booking Software UK`,
      metaDescription: "Discover Yelowsoft's cost-effective ready to use taxi dispatch software UK with advanced features, real-time analytics, and seamless integration. Get a free demo. ",
      ogImage: SocialDefaultImage,
      twitterImage: SocialDefaultImage
}

export const IotfleetmanagementMeta = {
      metaTitle: `IoT-Powered Taxi Fleet Management: The Future of Smarter Dispatch`,
      metaDescription: "Discover how IoT is transforming taxi fleet management. From real-time tracking to predictive maintenance, explore why IoT-powered dispatch software is the future.",
      ogImage: Whitepaperiotthumb,
      twitterImage: Whitepaperiotthumb
};
export const CybersecurityridehailingprotectingdriverpassengerdataMeta = {
      metaTitle: `Cybersecurity in Ride-Hailing: Protect Passenger Data`,
      metaDescription: "Explore top threats in ride-hailing cybersecurity and discover how YelowSoft protects passenger and driver data with a secure, compliant platform.",
      ogImage: Cybersecurityhumb,
      twitterImage: Cybersecurityhumb
};